import type { ConsentReport } from "@/lib/consent-record";

export function reportConsentChoice(report: ConsentReport): void {
  if (typeof fetch === "undefined") {
    return;
  }

  try {
    void fetch("/api/consent", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(report),
      keepalive: true,
    }).catch(() => {
      // Recording consent must not break the product.
    });
  } catch {
    // Private mode or a blocked fetch should not block Accept / Reject.
  }
}
